module.exports = __webpack_public_path__ + "static/media/logo-numera-mark.dec2c240.svg";